import type { DiscoverCollectionApi } from 'api-typings/users/users';
import { DiscoverCollectionTypeApi } from 'api-typings/users/users';
import { transformDiscoverCollection } from '../discover-collections/discover-collections.transformers';
import type { PredefinedDiscoverCollection } from './predefined-discover-collections.model';

export function transformPredefinedDiscoverCollection(
  discoverCollection: DiscoverCollectionApi,
): PredefinedDiscoverCollection {
  const predefinedDiscoverCollection =
    transformDiscoverCollection(discoverCollection);
  const seoUrl =
    predefinedDiscoverCollection.type ===
    DiscoverCollectionTypeApi.LISTS_FAVORITES
      ? 'favorites'
      : predefinedDiscoverCollection.type ===
          DiscoverCollectionTypeApi.LISTS_MY_HIRES
        ? 'my-hires'
        : predefinedDiscoverCollection.type ===
            DiscoverCollectionTypeApi.LISTS_MY_CLIENTS
          ? 'my-clients'
          : predefinedDiscoverCollection.type ===
              DiscoverCollectionTypeApi.LISTS_RECENTLY_VIEWED_USERS
            ? 'recently-viewed-users'
            : predefinedDiscoverCollection.type ===
                DiscoverCollectionTypeApi.LISTS_GROUP_FEED_ITEMS
              ? 'bookmarked-group-posts'
              : undefined;

  if (!seoUrl) {
    throw new ReferenceError(`Collection must have a predefined type`);
  }

  return {
    ...predefinedDiscoverCollection,
    seoUrl,
  };
}
